import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Moon, Sun, LogOut, Trophy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MONETIZATION_ENABLED } from "@/lib/features";

export default function TopBar({ onToggleTheme, theme }) {
  const { user, logout } = useAuth();
  return (
    <header
      className="sticky top-0 z-30 backdrop-blur-xl bg-background/70 border-b border-border"
      data-testid="topbar"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between px-4 h-14">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <span className="inline-block w-7 h-7 rounded-lg bg-primary flex items-center justify-center">
            <span className="text-primary-foreground font-heading font-black text-lg">R</span>
          </span>
          <span className="font-heading font-black text-lg tracking-tight">
            <span className="text-primary">Ri</span>vendas
          </span>
        </Link>

        <div className="flex items-center gap-2">
          {user && (
            <>
              <Link
                to="/leaderboard"
                data-testid="topbar-leaderboard"
                className="hidden md:inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-sm font-medium hover:bg-secondary transition-colors"
              >
                <Trophy size={16} className="text-primary" /> Ranking
              </Link>
              {MONETIZATION_ENABLED && (
                <Link
                  to="/pagamentos"
                  data-testid="topbar-payments"
                  className="hidden md:inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-sm font-medium hover:bg-secondary transition-colors"
                >
                  <span className="text-primary">💎</span> Créditos
                  {user.boost_credits > 0 && (
                    <span className="ml-1 bg-primary text-primary-foreground text-[10px] font-bold px-1.5 rounded-full">
                      {user.boost_credits}
                    </span>
                  )}
                </Link>
              )}
            </>
          )}
          <button
            data-testid="theme-toggle"
            onClick={onToggleTheme}
            className="p-2 rounded-lg hover:bg-secondary transition-colors"
            aria-label="Alternar tema"
          >
            {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          {user ? (
            <>
              <Link
                to="/profile"
                data-testid="topbar-user"
                className="text-sm font-medium hidden sm:block hover:text-primary"
              >
                {user.name?.split(" ")[0]}
              </Link>
              <Button
                variant="ghost"
                size="sm"
                onClick={logout}
                data-testid="logout-btn"
                className="gap-1"
              >
                <LogOut size={16} /> <span className="hidden sm:inline">Sair</span>
              </Button>
            </>
          ) : (
            <Link to="/login">
              <Button size="sm" data-testid="login-topbar-btn">Entrar</Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
